{
  "file_preview": {
    "confirm_delete_content": "Cliquez sur confirmer pour supprimer {{filename}}",
    "delete_aria_label": "supprimer {{filename}}"
  },
  "upload_file": {
    "drag_or_click": "Glissez un document ici ou cliquez pour télécharger (taille maximale : {{maxFileSize}} Mo)",
    "uploading": "Téléchargement, cela peut prendre une minute...",
    "max_file_size_error": "Taille de fichier maximale : {{max}}Mo, taille actuelle : {{current}}Mo",
    "unsupported_file_type_error": "Type de fichier non pris en charge : {{type}}"
  },
  "form": {
    "validation": {
      "url_or_file_required": "Veuillez saisir une URL ou téléverser le document"
    },
    "labels": {
      "document_name": "Nom du document",
      "document_url": "URL du document"
    },
    "or": "ou"
  },
  "actions": {
    "document": "Document"
  },
  "modal": {
    "add_document": "Ajouter un document"
  },
  "fallback": {
    "default_filename": "Doc"
  }
}
